/* import __COLOCATED_TEMPLATE__ from './discrete-percentage-stepper.hbs'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { formatBps } from '@capital/intl/utils';
const MAX_BPS = 100_00;
const MIN_BPS = 0;
const DEFAULT_BPS = 0;
let DiscretePercentageStepper = (_dec = computed('percentageValue'), _class = class DiscretePercentageStepper extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "maxPercentage", this.bpsToPercentage(typeof this.args.maxBps !== 'undefined' ? this.args.maxBps : MAX_BPS));
    _defineProperty(this, "minPercentage", this.bpsToPercentage(typeof this.args.minBps !== 'undefined' ? this.args.minBps : MIN_BPS));
    _initializerDefineProperty(this, "percentageValue", _descriptor2, this);
  }
  onChange(event) {
    const bps = event.detail.value * 100;
    this.percentageValue = this.bpsToPercentage(bps);
    this.args.onUpdate(bps);
  }

  // NOTE: market-stepper uses a <input type="number"/> so the % sign can't be part of the input
  // without being able to change the width of market-stepper's <input> based on different numbers' length,
  // we have to roughly calculate where the % sign needs to be
  // so that the % sign and the number (NOT the <input> element) stays close as if they are in the same <input>
  get percentSignPosition() {
    let position = 40;
    if (this.percentageValue < 10) {
      if (Math.floor(this.percentageValue) === this.percentageValue) {
        // 1. [0,10) integer
        position = 50;
      } else {
        // 2. [0,10) non-integer
        position = 44;
      }
    } else if (this.percentageValue < 100) {
      if (Math.floor(this.percentageValue) === this.percentageValue) {
        // 3. [10,100) integer
        position = 46;
      } else {
        // 4. [10,100) non-integer
        position = 40;
      }
    } else {
      position = 41;
    }
    return `right: ${position}px;`;
  }
  bpsToPercentage(value) {
    return Number.parseFloat(formatBps(value, this.intl).replace(/%/g, ''));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "percentageValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.bpsToPercentage(typeof this.args.bps !== 'undefined' ? this.args.bps : DEFAULT_BPS);
  }
}), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "percentSignPosition", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "percentSignPosition"), _class.prototype), _class);
export { DiscretePercentageStepper as default };